import styled from "styled-components";

import React, { useEffect, useState } from "react";

import Dialog from "@mui/material/Dialog";
import { Row } from "simple-flexbox";

export const ColumnDiv = styled.div`
  padding: 22px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: ${(props) => props.width || "30px"};
  margin-right: ${(props) => props.margin || "0px"};
  height: ${(props) => props.height || "auto"};
  margin-top: ${(props) => props.marginTop || "0px"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  padding-bottom: 25px;
  padding-top: 20px;
  @media (max-width: 680px) {
    width: ${(props) => props.smLWidth};
  }
  @media (max-width: 480px) {
    width: ${(props) => props.smWidth};
    margin-right: ${(props) => props.smMargin};
    margin-bottom: ${(props) => props.smMarginBottom};
  }
`;

export const Heading = styled.div`
  font-size: ${(props) => props.fontSize || "24px"};
  font-weight: ${(props) => props.fontWeight || "600"};
  line-height: 30px;
  letter-spacing: 0em;
  text-align: ${(props) => props.align || "center"};
  padding: ${(props) => props.padding || "0px"};
  color: ${(props) => props.color || "#000000"};
  @media (max-width: 600px) {
    font-size: ${(props) => props.smLFont};
  }
  @media (max-width: 500px) {
    font-size: ${(props) => props.smFont};
    line-height: 20px;
    padding: ${(props) => props.smPadding};
  }
  @media (max-width: 400px) {
    font-size: ${(props) => props.xsFont};
  }
`;

const StyledButton = styled.button`
  background-color: ${(props) => props.backgroundColor || "transparent"};
  color: ${(props) => props.color || "#000"};
  padding: ${(props) => props.padding || "10px 20px"};
  margin: ${(props) => props.margin || "15px"};
  border-radius: ${(props) => props.borderRadius || "5px"};
  border: none;
  cursor: pointer;
  font-size: 16px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:hover {
    opacity: ${(props) => (props.disabled ? "0.5" : "0.9")};

  }
`;

const ConfirmedDialog = ({ open, handleClose, handleConfirmed, label }) => {

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    // Reset the button's disabled state when the dialog opens
    if (open) setIsButtonDisabled(false);
  }, [open]);

  const onConfirmClick = () => {
    setIsButtonDisabled(true); // Disable the button
    handleConfirmed(); // Trigger the confirmed action
  };


  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
          margin: "50px",
          padding: "20px",
        },
      }}
    >
      <Heading
        fontWeight={"400"}
        fontSize={"22px"}
        smLFont={"20px"}
        smFont={"17px"}
        xsFont={"16px"}
        padding={"10px 20px"}
      >

        {label === "status"
          ? `Do You Want To Change Status?`
          : `Do You Want To ${label}?`}

      </Heading>
      <Row justifyContent="flex-end">
        <StyledButton
          backgroundColor="orange"
          color="#fff"

          onClick={onConfirmClick}
          disabled={isButtonDisabled} // Disable when clicked

        >
          Yes
        </StyledButton>
        <StyledButton
          backgroundColor="black"
          color="wheat"
          onClick={handleClose}
        >
          Cancel
        </StyledButton>
      </Row>
    </Dialog>
  );
};

export default ConfirmedDialog;
